// Copyright (c) 2017 Deere & Company

import PercentageDebitModal from './percentage-debit-modal-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    amountDebit: state.tcsm.percentageDebit.amountDebit,
    busyCounter: state.tcsm.percentageDebit.busyCounter,
    debit: state.tcsm.percentageDebit.debit,
    isEditable: false,
    isPercentageDebitModalVisible: state.tcsm.percentageDebit.isPercentageDebitModalVisible
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    queryParams: parentProps.queryParams,
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PercentageDebitModal);



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-debit-modal/index.js